import React from 'react';
import {reduxForm} from 'redux-form';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import LabelWithTooltipCell from '../../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell.js';
import {gridsNames} from '../../../../../enums/gridsNames';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import {FetchEntitiesFilters} from '../../../../../enums/fetchEntitiesFilters';
import {EntityPropertyTypes} from '../../../../../enums/entityPropertyTypes';
import WidthCell from '../../../../Common/CustomGridCells/WidthCell/widthCell';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import CheckMarkCell from '../../../../Common/CustomGridCells/CheckMarkCell/checkMarkCell';
import {enumTypes, getEnumLabel} from '../../../../../utils/enumHelper';


class MaterialTypesViewGrid extends React.PureComponent{

  filterConfig = [
    {fieldName: 'businessId', filterName: 'businessId', getOptions: false},
    {fieldName: 'materialName', filterName: 'materialName', getOptions: false},
    ...(PermissionManager.isQplEnabled() ? [
      {fieldName: 'supplierOrganizationStatus', filterName: 'supplierOrganizationStatus', getOptions: true},
    ] : []),
  ];

  constructor (props){
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.materialtypes.grid.');

    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    return [
      {
        fieldName: 'businessId',
        title: this.labels.get('columns.materialcode.title'),
        filterType: filterTypes.MULTI_SELECT_ASYNC,
        filterName: 'businessId',
        fetchConfig: {
          entityType: EntityPropertyTypes.MATERIAL_TYPE_BUSINESS_ID,
          filter: [FetchEntitiesFilters.ALL],
          action: this.props.actions.fetchEntities
        },
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return params.data?.businessId;
          },
        }
      },
      {
        fieldName: 'materialName',
        title: this.labels.get('columns.materialname.title'),
        filterType: filterTypes.MULTI_SELECT_ASYNC,
        filterName: 'materialName',
        fetchConfig: {
          entityType: EntityPropertyTypes.MATERIAL_TYPE_NAME,
          filter: [FetchEntitiesFilters.ALL],
          action: this.props.actions.fetchEntities
        },
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return params.data?.materialName;
          },
        }
      },
      {
        fieldName: 'width',
        title: this.labels.get('columns.width.title'),
        filterType: filterTypes.NONE,
        width: 110,
        columnOptions: {
          sortable: false,
          cellComponent: WidthCell,
        }
      },
      {
        fieldName: 'm_defrostingTime',
        title: this.labels.get('columns.defrostingTime.title'),
        filterType: filterTypes.NONE,
        width: 170,
        columnOptions: {
          sortable: false,
          valueGetter: (params) => {
            return params.data?.m_defrostingTime;
          },
        }
      },
      ...((PermissionManager.isQplEnabled() || PermissionManager.isCoCEnabled()) ? [
        {
          fieldName: 'qplRules',
          title: this.labels.get('columns.qpl.title'),
          filterType: filterTypes.NONE,
          width: 100,
          columnOptions: {
            sortable: false,
            cellComponent: CheckMarkCell,
            valueGetter: (params) => {
              return params.data.qplRules?.length
            },
          },
        }] : []),
      ...(PermissionManager.isQplEnabled() ? [
      {
        fieldName: 'supplierOrganizationStatus',
        title: this.labels.get('columns.supplierOrgStatus.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'supplierOrganizationStatus',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return params.data?.supplierOrganizationStatus ? getEnumLabel(enumTypes.SUPPLIER_ORGANIZATION_STATUS)(params.data.supplierOrganizationStatus) : '';
          },
        }
      }] : []),

    ]
  };

  render() {
    return (
      <div className="administration-view-grid">
        <Grid gridName={gridsNames.ADMINISTRATION_MAT_SETTINGS_MATERIAL_TYPES}
              columnsConfig = {this.columnsConfig}
              actions={this.props.actions}
              filterConfig={this.filterConfig}
        >
        </Grid>
      </div>
    );
  }
}

export default reduxForm({
    form: 'materialTypesViewGrid'
  }
)(MaterialTypesViewGrid);
